import React from 'react';
import './SkipUploadModal.scss';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import AppButton from 'src/components/base/Button/Button';
import { Typography } from "src/latest/src/components";


interface prop {
  handleOnclick: () => void
}

const SkipUploadModal: React.FC<prop> = ({ handleOnclick }) => {
  const dispatch = useDispatch();

  const handleGoBackClick = () => {
    dispatch(clearModalContent());
  };

  return (
    <div className='skip-upload-modal'>
      <div className='d-flex justify-content-center'>
        <Typography variant='size-18' className='mt-4 text-1'>
          By automatically collecting a signed consent form before your first
          meeting, we can save your practice time and effort.
        </Typography>
      </div>

      <div className='d-flex justify-content-center'>
        <Typography variant='size-18' className='mt-4 text-2'>
          If your practice requires the completion of a complex consent form, or
          a consent form in conjunction with other forms, you can choose to skip
          this page and collect these documents off-platform.
        </Typography>
      </div>
      <div className='d-flex justify-content-center mt-5'>
        <div className='me-3'>
          <AppButton
           onClick={handleGoBackClick}
           className='goback-button fw-bold'
           label={"Go Back"}
          />
        </div>
        <div className='ms-4'>
          <AppButton
           onClick={() => {
            handleGoBackClick();
            handleOnclick();
          }}
           variant="light"
           className='cwu-button fw-bold'
           label={"Continue Without Uploading"}
          />
        </div>
      </div>
    </div>
  );
};

export default SkipUploadModal;
